import { Calendar } from 'data/firestore/agent/calendar/types';

const getCollapsedDays = (
    availabilityPerDay: Array<Calendar['availability']>,
): boolean[] => {
    const collapsed = availabilityPerDay.map((availability) => availability.length === 0);

    // Collapsing every column would leave the week unreadable, so when nothing is
    // available at all (no calendars selected, still loading) keep the full layout.
    if (collapsed.every(Boolean)) {
        return collapsed.map(() => false);
    }

    return collapsed;
};

export default getCollapsedDays;
